import React from 'react'
import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { defaultSort } from 'constants/caSortOptions'
import { DEFAULT_FLAVOUR, LEGACY_FLAVOURS } from 'constants/flavours'
import { SEARCH } from 'constants/controllers'
import PagedContainer from 'redux/containers/pages/search/PagedContainer'
import InfiniteContainer from 'redux/containers/pages/search/InfiniteContainer'
import Left from 'pages/search/Left'
import NotFound from 'components/NotFound'
import { QAHeader } from './Header'
import { replaceUrl } from 'libraries/front-end-core/core/history'

export default new Controller({
  name: SEARCH,
  route: '(:flavour/)search/:searchType',
  controller (Router, { scrollMain, query, pageView, params: { aol, flavour, searchType } }, render) {
    const { q: searchPhrase, p: pageNumber = '1' } = query
    if (LEGACY_FLAVOURS.includes(flavour)) {
      return replaceUrl(
        getUrl(
          SEARCH,
          {
            aol,
            flavour: DEFAULT_FLAVOUR,
            searchPhrase,
            searchType
          },
          query
        )
      )
    }
    const pageLimit = 10
    const pageId = getUrl(SEARCH, { aol, flavour: searchType === 'qa' && flavour, searchPhrase, searchType, pageNumber: pageNumber === 'all' && 'all' })
    const bottleLink = flavour => getUrl(SEARCH, { aol, flavour, searchPhrase, searchType })
    const Header = searchType === 'qa' ? () => <QAHeader {...{ aol, flavour, searchType, searchPhrase, query }} /> : null

    if (searchType === 'ca' && !query.sort) {
      query.sort = defaultSort
    }

    const layoutData = {
      bottleLink,
      className: searchType,
      flavour,
      pageId,
      pageView,
      query,
      searchPhrase,
      searchType
    }

    if (pageNumber === 'all') {
      render(
        {
          Main: InfiniteContainer,
          Header,
          Left
        },
        {
          flavour,
          pageLimit,
          pageNumber: false,
          searchPhrase,
          searchType,
          query
        },
        layoutData
      )
    } else if (+pageNumber > 0) {
      render(
        {
          Main: PagedContainer,
          Header,
          Left
        },
        {
          flavour,
          pageLimit,
          pageNumber: +pageNumber || 1,
          query,
          searchPhrase,
          searchType
        },
        layoutData
      )
    } else {
      render(
        { Main: NotFound },
        {},
        { pageId }
      )
    }

    return pageId
  }
})
